import React from "react";
import "./ProductOfferings.css";
import image1 from "../assets/product_images_new/1liter.png";
import image2 from "../assets/product_images_new/500ml.png"; 
import image3 from "../assets/product_images_new/250ml.png";

const ProductOfferings = () => {
    const products = [
      {
        id: 1,
        image: image1,
        title: "1LTR Premium Water",
        description: "Stay hydrated all day with our 1LTR bottle.",
        sizes: "1000ml",
      },
      {
        id: 2,
        image: image2,
        title: "500ML Premium Water",
        description: "Perfect for daily refreshment, available in 500ML.",
        sizes: "500ml",
      },
      {
        id: 3,
        image: image3,
        title: "200ML Premium Water",
        description: "Pure hydration in a compact 200ML size.",
        sizes: "200ml",
      },
  ];

  return (
    <section className="product-offerings-section" id="product-section">
      <div className="container">
        <h2 className="offerings-title">OUR PRODUCTS</h2>
        <p>Purity | Luxury | Hydration</p>
        <p className="offerings-subtitle">
        Lusora brings you premium packaged drinking water with minerals, crafted for those who appreciate purity and elegance.<br/>Every sip offers a refreshing taste with a touch of luxury, making hydration a sophisticated experience.
        </p>

        <div className="offerings-content">
          {products.map((product) => (
            <div key={product.id} className="offering-item">
              <img
                src={product.image}
                alt={product.title}
                className="bottle-image"
              />
              <h3 className="bottle-title">{product.title}</h3>
              <p className="bottle-description">{product.description}</p>
              <p className="bottle-size">Size: {product.sizes}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductOfferings;
